import Input from '@material-ui/core/Input';

/**
 * @deprecated
 * Exporting the Input component from the Material UI library.
 */
export default Input;
